import { Navigate, useParams, useSearchParams } from 'react-router-dom'

export default function CommunityPostDetailPage() {
  const { postId } = useParams<{ postId: string }>()
  const [searchParams] = useSearchParams()
  const trimmedPostId = postId?.trim() ?? ''

  if (!trimmedPostId.length) {
    return <Navigate to="/board" replace />
  }

  const redirectSearchParams = new URLSearchParams(searchParams)
  redirectSearchParams.delete('fromBoard')
  redirectSearchParams.set('post', trimmedPostId)

  const queryString = redirectSearchParams.toString()
  const redirectPath = queryString.length > 0 ? `/board?${queryString}` : '/board'

  return <Navigate to={redirectPath} replace />
}
